import { forEach } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { ChangeContext, LabelType, Options } from '@angular-slider/ngx-slider';

import { CatalogueCategoryType, CatalogueCategoryWithChildrenType, FilterNameFieldType, InternalProductFilterType, InternalProductWithRatingsWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';
import { Subject, takeUntil } from 'rxjs';
import { StorageHelper } from '@diktup/frontend/helpers';
import { AppService, UtilsService } from '../../../services';

@Component({
  template: '',
})
export class BaseProductListFilterComponent implements OnInit {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

 @Input() category: CatalogueCategoryType;

  params = {};
  maxPrice: number;
  minValue: number;
  maxValue: number;
  allLimits: any[] = [];
  someRange2config: any;
  initialMinValue: number;
  initialMaxValue: number;
  priceRange: any = [0, 100];
  isProductByCategory = false;
  filter: InternalProductFilterType;
  initialFilter: InternalProductFilterType;
  catalogueCategories: FilterNameFieldType[];
  navItems: CatalogueCategoryWithChildrenType[];
  categories: CatalogueCategoryWithChildrenType[];
  productFilter: Map<number, any> = new Map<number, any>();
  initialProducts: InternalProductWithRatingsWithFavoriteStatusType[];
  filtredProducts: InternalProductWithRatingsWithFavoriteStatusType[];

  constructor(
    protected router: Router,
    protected appService: AppService,
    protected utilsService: UtilsService,
    protected activeRoute: ActivatedRoute,
    protected storageHelper: StorageHelper,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    this.appService.fromPrice = null;
    this.appService.toPrice = null;
    activeRoute.queryParams.subscribe((params) => {
      this.params = params;
      if (params['categoryUrl']) {
        this.isProductByCategory = true;
        this.appService.selectedCategories = [];
        this.changeDetectorRef.markForCheck();
      }
      if (params['minPrice'] && params['maxPrice']) {
        this.appService.fromPrice = '' + params['minPrice'];
        this.appService.toPrice = '' + params['maxPrice'];
      }
    });
    this.appService.getCatalogueCategoriesByTargetWithChildren()
    .subscribe((res) => {
      this.navItems = res;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnInit(): void {
    this.appService.pageIndex$ = 0;
    this.appService.categories$.subscribe((categories: CatalogueCategoryWithChildrenType[]) => {
      this.categories = categories;
      this.changeDetectorRef.markForCheck();
    });
    this.appService.initialProducts$.pipe(takeUntil(this.unsubscribeAll)).subscribe((productsPaginated) => {
      if (productsPaginated) {
        this.initialFilter = productsPaginated?.filter;
        const catalogueCategories = productsPaginated?.filter?.catalogueCategories.filter((cat) => cat.id !== this.category?.id);
        this.productFilter.set(2, {
          maxValue: parseInt(this.initialFilter?.priceRange?.max, 10),
          minValue: parseInt(this.initialFilter?.priceRange?.min, 10),
          filter: {
            ...productsPaginated?.filter,
            catalogueCategories,
          },
          priceRange: [0, +this.initialFilter?.priceRange?.max],
          maxPrice: parseInt(this.initialFilter?.priceRange?.max, 10),
          someRange2config: {
            behaviour: 'drag',
            connect: [true, true, true],
            step: 5,
            start: [0, 100],
            pageStep: 1,
            range: {
              min: 0,
              max: parseInt(this.initialFilter?.priceRange?.max),
            },
          },
        });
        this.initialMaxValue = parseInt(this.initialFilter?.priceRange?.max, 10);
        this.initialMinValue = parseInt(this.initialFilter?.priceRange?.min, 10);
        forEach(this.initialFilter.productAttributesValues, (attribute) => {
          this.allLimits = [
            ...this.allLimits,
            {
              min: attribute.attributeValues.length < 5 ? attribute.attributeValues.length : 5,
            },
          ];
        });
        this.changeDetectorRef.markForCheck();
      }
      this.initialProducts = productsPaginated?.objects;
      this.changeDetectorRef.markForCheck();
    });
    this.appService.filtredProducts$.pipe(takeUntil(this.unsubscribeAll)).subscribe((filtredProducts) => {
      if (filtredProducts) {
        const catalogueCategories = filtredProducts?.filter?.catalogueCategories?.filter((cat) => cat.id !== this.category?.id);
        this.filtredProducts = filtredProducts.objects;
        this.filter = filtredProducts?.filter;
        this.productFilter.set(1, {
          maxValue: parseInt(this.filter?.priceRange?.max, 10),
          minValue: parseInt(this.filter?.priceRange?.min, 10),
          filter: {
            ...filtredProducts?.filter,
            catalogueCategories,
          },
          // filter: filtredProducts?.filter,
          priceRange: [0, +this.filter?.priceRange?.max],
          maxPrice: parseInt(this.filter?.priceRange?.max, 10),
          someRange2config: {
            behaviour: 'drag',
            connect: [true, true, true],
            step: 5,
            start: [0, 100],
            pageStep: 1,
            range: {
              min: 0,
              max: parseInt(this.filter?.priceRange?.max),
            },
          },
        });
        this.maxValue = parseInt(this.filter?.priceRange?.max, 10);
        this.minValue = parseInt(this.filter?.priceRange?.min, 10);
        forEach(this.filter.productAttributesValues, (attribute) => {
          this.allLimits = [
            ...this.allLimits,
            {
              min: attribute.attributeValues.length < 5 ? attribute.attributeValues.length : 5,
            },
          ];
        });
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  categoriesId(e: any, id: string, attr: string, value: string) {
    if (e.target.checked) {
      this.appService.pageIndex$ = 0;
      this.appService.selectedCategories.push(id);
    } else {
      this.appService.pageIndex$ = 0;
      this.appService.selectedCategories = this.appService.selectedCategories.filter((m) => m !== id);
    }
    this.onAttrClick(attr, value);
    this.changeDetectorRef.markForCheck();
  }

  getBrandId(e: any, id: string, attr: string, value: string) {
    if (e.target.checked) {
      this.appService.pageIndex$ = 0;
      this.appService.selectedBrands.push(id);
    } else {
      this.appService.pageIndex$ = 0;
      this.appService.selectedBrands = this.appService.selectedBrands.filter((m) => m !== id);
    }
    this.onAttrClick(attr, value);
    this.changeDetectorRef.markForCheck();
  }

  attributesId(event: any, id: string, attr: string, value: string) {
    this.appService.pageIndex$ = 0;
    if (event.target.checked) {
      this.appService.productAttributes.push(id);
    } else {
      this.appService.productAttributes.pop();
    }
    this.onAttrClick(attr, value);
    this.changeDetectorRef.markForCheck();
  }

  containsAttrInUrl(type: string, value: string) {
    const currentQueries = this.params[type] ? this.params[type].split(',') : [];
    return currentQueries && currentQueries.includes(value);
  }

  getUrlForAttrs(type: string, value: string) {
    let currentQueries = this.params[type] ? this.params[type].split(',') : [];
    currentQueries = this.containsAttrInUrl(type, value) ? currentQueries.filter((item) => item !== value) : [...currentQueries, value];
    return currentQueries.join(',');
  }

  onAttrClick(attr: string, value: string) {
    this.router.navigate([], { queryParams: { [attr]: this.getUrlForAttrs(attr, value), page: 1 }, queryParamsHandling: 'merge' });
  }

  cleanAll() {
    this.appService.selectedBrands = [];
    this.appService.selectedCategories = [];
    this.appService.productAttributes = [];
    this.appService.fromPrice = null;
    this.appService.toPrice = null;
    this.appService.getSimpleProductsWithRatingsWithFavoriteStatusWithFilter().subscribe();
    this.router.navigate([]);
  }

  onValueChange(event: ChangeContext) {
    this.appService.pageIndex$ = 0;
    this.appService.fromPrice = '' + event.value;
    this.appService.toPrice = '' + event.highValue;
    this.priceRange = [event.value / 10, event.highValue / 10];
    this.router.navigate([], {
      queryParams: {
        minPrice: (this.priceRange[0].toFixed(3) * 10).toFixed(3),
        maxPrice: (this.priceRange[1].toFixed(3) * 10).toFixed(3),
        page: 1,
      },
      queryParamsHandling: 'merge',
    });
    this.changeDetectorRef.markForCheck();
  }

  sliderOptions(): Options {
    return {
      floor: parseInt(this.filter?.priceRange?.min, 10),
      ceil: parseInt(this.filter?.priceRange?.max, 10),
      getSelectionBarColor: (value: number): string => {
        return 'black';
      },
      translate: (value: number, label: LabelType): string => {
        switch (label) {
          case LabelType.Low:
            return value + ' DT';
          case LabelType.High:
            return value + ' DT';
          default:
            return value + ' DT';
        }
      },
    };
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
